import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AppConfigService } from './app-config.service';
import { ApiBaseService } from './api-base.service';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class DatanetService extends ApiBaseService {
    constructor(appConfig: AppConfigService, http: HttpClient) {
        super(appConfig, http);
    }

    callback = (request: any): Observable<any> => {
        return this.http.post(`${this.baseUrl()}/Callback/SubmitCallback`, request, {
            headers: this.headers(),
        });
    };
}
